import {
  FACEBOOK_CAMPAIGN_FORM_DETAILS,
  FACEBOOK_CAMPAIGN_FORM_ERROR,
  FACEBOOK_CAMPAIGN_ID,
  FACEBOOK_CAMPAIGN_ERROR,
} from "../../types";

const CampaignReducer = (state, action) => {
  switch (action.type) {
    case FACEBOOK_CAMPAIGN_FORM_DETAILS:
      return { ...state, form_details: action.payload };

    case FACEBOOK_CAMPAIGN_FORM_ERROR:
      return { ...state, form_errors: action.payload };

    case FACEBOOK_CAMPAIGN_ID:
      return { ...state, campaign_id: action.payload };

    case FACEBOOK_CAMPAIGN_ERROR:
      return { ...state, campaign_error: action.payload };

    default:
      return state;
  }
};

export default CampaignReducer;